/**
 * @description Component-TutotialButton
 */
import './index.less';

import React, { FC } from 'react';

import { FAQ_LINKS } from '@/constants/links';

import IconT from './assets/icon_nav_tutorial.svg?react';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const TutorialButton: FC<IPropTypes> = function () {
  // const { t } = useTranslation();
  // const { dataTheme } = useTheme();
  return (
    <a href={FAQ_LINKS.TUTORIAL_FAQ} target="_blank" type="ghost" rel="noreferrer" className="syn-tutorial-button">
      <IconT />
      {/* {t('common.tutorials')} */}
    </a>
  );
};

export default TutorialButton;
